import React from 'react';
import { LandingPage } from './pages/LandingPage';
import SeccionSecretaPage from './pages/seccion-secreta';
export default function App() {
  const path = window.location.pathname;
  // Si la URL es /seccion-secreta, mostramos la página secreta
  if (path === '/seccion-secreta') {
    return <SeccionSecretaPage data-id="element-0" />;
  }
  // En cualquier otra ruta, mostramos la landing normal
  return <LandingPage data-id="element-1" />;
}